export default {
  methods: {
    async validateBeforeSubmit() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.send()
      } else {
        return
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/formValidate.js